import type {Component, PanelLifecycleContext} from 'panel';

import type {Subscribable} from 'common/types/context/subscribable';

type CallbackFn = () => void;

export abstract class SubscribableContext implements PanelLifecycleContext, Subscribable {
  private subscriptions: CallbackFn[] = [];

  notifySubscribers() {
    for (const subscription of this.subscriptions) {
      subscription();
    }
  }

  subscribe(callback: CallbackFn) {
    this.subscriptions.push(callback);
    return this;
  }

  unsubscribe(callback: CallbackFn) {
    this.subscriptions = this.subscriptions.filter((cb) => cb !== callback);
    return this;
  }

  _componentSubscriptions: Map<Component<any>, CallbackFn> = new Map();

  bindToComponent(component: Component<any>) {
    // TODO resourceCustomSubscriptions should probably be built into Panel Contexts
    const customSubscriptions =
      ((component as any)[`resourceCustomSubscriptions`] as Map<TODO, CallbackFn>) || new Map();
    const callback = customSubscriptions.get(this.constructor) || component.update.bind(component);

    this._componentSubscriptions.set(component, callback);
    this.subscribe(this._componentSubscriptions.get(component)!);
  }

  unbindFromComponent(component: Component<any>) {
    this.unsubscribe(this._componentSubscriptions.get(component)!);
  }
}
